import React from "react";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import MuiLink from "@mui/material/Link";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material";

interface ILastListItemProps {
  description: string;
}

const LastListItem: React.FC<ILastListItemProps> = ({ description }) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: 344,
        height: 362,
        margin: theme.spacing(4, "auto"),
        boxShadow: "2px 2px 4px rgba(68, 68, 68, 0.15)",
        [theme.breakpoints.down("sm")]: {
          width: 300,
          height: 328,
        },
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Box p={4} fontStyle="italic">
          <Typography variant="body1" align="center">
            {description}&nbsp;
            <MuiLink
              href="https://www.linkedin.com/search/results/content/?keywords=AI Planet"
              target="_blank"
            >
              here
            </MuiLink>
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default LastListItem;
